"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
// @ts-ignore
var react_textfit_1 = require("react-textfit");
var seesignage_utils_1 = require("@seesignage/seesignage-utils");
var StyledDiv_1 = __importDefault(require("../StyledDiv"));
var values_1 = require("../../utils/values");
var getTextValue = function (_a) {
    var _b, _c;
    var value = _a.value, infopageValue = _a.infopageValue, textOptions = _a.textOptions;
    var textValue = (0, seesignage_utils_1.isStringInfopageContent)(infopageValue) ? infopageValue : value;
    var truncateLength = (_b = textOptions === null || textOptions === void 0 ? void 0 : textOptions.truncate) === null || _b === void 0 ? void 0 : _b.length;
    if (typeof textValue === 'string' &&
        typeof truncateLength === 'number' &&
        textValue.length >= truncateLength) {
        var text = textValue.substring(0, truncateLength);
        return ((_c = textOptions === null || textOptions === void 0 ? void 0 : textOptions.truncate) === null || _c === void 0 ? void 0 : _c.text) ? "".concat(text).concat(textOptions.truncate.text) : text;
    }
    return textValue;
};
var Text = function (_a) {
    var styles = _a.styles, value = _a.value, id = _a.id, textfit = _a.textfit, infopageValue = _a.infopageValue, textOptions = _a.textOptions;
    var textfitProps = (0, values_1.getTextFitProps)(styles, textfit);
    return (react_1.default.createElement(react_1.Fragment, null, textfitProps ? (react_1.default.createElement(react_textfit_1.Textfit, __assign({}, textfitProps, { throttle: 200 }), getTextValue({ value: value, infopageValue: infopageValue, textOptions: textOptions }))) : (react_1.default.createElement(StyledDiv_1.default, { id: id, styles: styles }, (0, seesignage_utils_1.isTextEditorInfopageContent)(infopageValue) ? (react_1.default.createElement("div", { dangerouslySetInnerHTML: { __html: infopageValue.html } })) : (getTextValue({ value: value, infopageValue: infopageValue, textOptions: textOptions }))))));
};
exports.default = Text;
//# sourceMappingURL=Text.js.map